<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col sm="12">
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  const ACCESS_TOKEN_KEY = 'access_token'
  const REFRESH_TOKEN_KEY = 'refresh_token'
  
  export default {
    name: 'logout',
    data: function () {
      return {
        errors: []
      }
    },
    mounted () {
      this.handleLogout()
    },
    methods: {
      handleLogout: function () {
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
        axios.defaults.headers.common['Accept'] = 'application/json'
        let accessToken = localStorage.getItem('access_token')

        if (accessToken !== null && accessToken !== '') {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken
        }

        let uri = window.apiUri + 'logout'
        axios.get(uri)
          .then(response => {
            localStorage.removeItem(ACCESS_TOKEN_KEY)
            localStorage.removeItem(REFRESH_TOKEN_KEY)
            this.$router.push('/')
          })
          .catch(error => {
            // Wu oh! Something went wrong
            console.log(error.response.data)
            this.errors.push(error.response.data)
            this.$router.push('/')
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Logout.vue